import { render, staticRenderFns } from "./m-text-field.vue?vue&type=template&id=86e3857a&scoped=true&"
import script from "./m-text-field.vue?vue&type=script&lang=js&"
export * from "./m-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e3857a",
  null
  
)

export default component.exports